import React, { Component } from "react";
import DashboradCount from "../components/DashboradCount/DashboradCount";
import TodayAppoinments from "../components/TodayAppoinments/TodayAppoinments";
import WaitingPatients from "../components/WaitingPatients/WaitingPatients";
import PendingDeletionRequest from "../components/PendingDeletionRequest/PendingDeletionRequest";
import CreatesNotes from "../components/CreatesNotes/CreatesNotes";
import ListOfUsers from "../components/ListOfUsers/ListOfUsers";
import PendingApprovals from "../components/PendingApprovals/PendingApprovals";
import PaymentHistory from "../components/PaymentHistory/PaymentHistory";
import InventoryAudit from "../components/InventoryAudit/InventoryAudit";
import LatestAddedProduct from "../components/LatestAddedProduct/LatestAddedProduct";
import SupplierRelatedParty from "../components/SupplierRelatedParty/SupplierRelatedParty";
import ListOfInvoices from "../components/ListOfInvoices/ListOfInvoices";
import ttmLodader from "../assets/images/ttm-loader.gif";

import { connect } from "react-redux";
import { fetchDashboardCountData } from "../redux";
import { checkIfPermitted, Permissions } from "../services/RolePermissionService";
import io from 'socket.io-client'
import history from "../utils/history";

export class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      isDataFetched: false
    }
  }  

  componentDidMount = async() => {
    document.title = 'Dashboard - TechToMedix';
    await this.props.fetchDashboardCountData();
    setTimeout(() => {
      this.setState({
        isDataFetched: true
      })
    }, 500);
  }

  getDashboardList = () =>{
     let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
     
      if(userInfo && userInfo.systemRole){
        let roleId = userInfo.systemRole;
       // console.log("roleId", roleId);
        
        switch (roleId) {
          //Super Admin
          case 1:
            return(
              <div className="row dashboard-name-wrapper">
                <div className="col-lg-4">
                  <ListOfUsers {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <PendingApprovals {...this.props.dashboardData}/>
                </div>
                <div className="col-lg-4">
                  <PaymentHistory {...this.props.dashboardData} />
                </div>          
            </div>
            )
            break;
        //Practitioner
          case 2:
            return(
              <div className="row dashboard-name-wrapper">
                <div className="col-lg-4">
                  <TodayAppoinments {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <WaitingPatients {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <PaymentHistory {...this.props.dashboardData} />
                </div>          
            </div>
            )
            break;            
        //Support Staff
          case 3:
            return(
              <div className="row dashboard-name-wrapper">
                <div className="col-lg-4">
                  <TodayAppoinments {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <WaitingPatients {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <PaymentHistory {...this.props.dashboardData} />
                </div>          
            </div>
            )
            break;

          //StockList
          case 4:
            return(
              <div className="row dashboard-name-wrapper">
                <div className="col-lg-4">
                  <InventoryAudit {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <LatestAddedProduct {...this.props.dashboardData} />
                </div>
                <div className="col-lg-4">
                  <SupplierRelatedParty {...this.props.dashboardData} />
                </div>          
            </div>
            )
            break;
            
          //Viewer
          case 5:
            return(
              <div className="row dashboard-name-wrapper">
                <div className="col-lg-4">
                  <PaymentHistory {...this.props.dashboardData} />
                </div> 
                <div className="col-lg-4">
                  <LatestAddedProduct {...this.props.dashboardData} />
                </div>     
                <div className="col-lg-4">
                  <ListOfInvoices {...this.props.dashboardData} />
                </div>    
            </div>
            )
            break;
          default:
          return(
            <div className="row dashboard-name-wrapper">
              <div className="col-lg-4">
                <TodayAppoinments {...this.props.dashboardData} />
              </div>
              <div className="col-lg-4">
                <WaitingPatients {...this.props.dashboardData} />
              </div>
              <div className="col-lg-4">
                <PaymentHistory {...this.props.dashboardData} />
              </div>          
          </div>
          )
            break;
        }
      } else {
        return null;
      }
      
  }
  
  

 isEmpty = (obj) => {
    let hasOwnProperty = Object.prototype.hasOwnProperty;
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

goBack = () => {
  history.goBack();
}

  render() {

    if(!this.state.isDataFetched){
      return (
        <div className="dashboard-loader">
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <div>
        {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
        <DashboradCount {...this.props.dashboardData} />
         {this.getDashboardList()}
        {checkIfPermitted(Permissions.MANAGE_NOTES) && (
          <div className="row notes-wrapper">
            <div className="col-md-12">
              <CreatesNotes />
            </div>
          </div>
        )}
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    dashboardData: state.dashboardCounts,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDashboardCountData: () =>      dispatch(fetchDashboardCountData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
